module.exports = __webpack_public_path__ + "static/media/eecs_crop_052123.86e4b809.png";